// extracted by mini-css-extract-plugin
module.exports = {"marketSelector":"MarketSelector_marketSelector__8dD_u","marketSelectorLabel":"MarketSelector_marketSelectorLabel__YPokn"};